import React from "react";

export default function SurfaceTableau({ ...props }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        borderBottom: "1px solid #DDD",
      }}
    >
      {props.children}
    </div>
  );
}
